import { render } from "./VendorSideMenu.vue?vue&type=template&id=252cfa6d&scoped=true"
import script from "./VendorSideMenu.vue?vue&type=script&lang=js"
export * from "./VendorSideMenu.vue?vue&type=script&lang=js"

import "./VendorSideMenu.vue?vue&type=style&index=0&id=252cfa6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252cfa6d"]])

export default __exports__